

import React from 'react';
import { TableCell, TableRow } from '@mui/material';
import { Image, Space } from "antd";
import customStyles from "../../../../../assets/styles/customStyles";
import { paymentHead } from "../../../../../config/constant";
import { NavLink } from "react-router-dom";
import clsx from "clsx";
import CustomInfiniteScroll from "../../../../Shared/components/CustomInfiniteScroll";
import ViewIcon from "../../../../../assets/images/icon_actions/View.svg";
import { checkCRUDPermission, getColumnWidth, currencyFormat } from "../../../../../helpers/utilities";
import moment from 'moment';

export const ListTable = (props) => {
    const { onRequestSort, sortOrder, sortBy,
        details, loadMore, onView,
        loadMoreContent, loadMoreTask, roleManagement } = props;

    const classes = customStyles();
    return (
        <CustomInfiniteScroll
            loadMore={loadMore}
            loadMoreContent={loadMoreContent}
            loadMoreTask={loadMoreTask}
            heads={paymentHead}
            onRequestSort={(sortBy, sortOrder) => onRequestSort(sortBy, sortOrder)}
            sortOrder={sortOrder}
            sortBy={sortBy}
            width={true}
            component={
                <>
                    {
                        !loadMore || details === '' ? (
                            <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                <TableCell className={classes.textAlignCenter} colSpan={paymentHead.length}><div className={classes.loadMoreCircle}></div></TableCell>
                            </TableRow>
                        ) : (
                            <React.Fragment>
                                {
                                    details && Array.isArray(details) && details.length > 0 ? details.map((data, i) => (
                                        <TableRow
                                            key={i} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                            <TableCell style={{ width: getColumnWidth(paymentHead, 0) }}>
                                                {
                                                    roleManagement !== '' && checkCRUDPermission('Payment History', 'view', 'Admin') ?
                                                        <NavLink style={{ width: getColumnWidth(paymentHead, 0) }} to={"#"} onClick={() => onView(data)} className={clsx(classes.color, classes.wordBreak, classes.positionRelative, classes.PaddingRight50, classes.disBlock, classes.bold)}>{data?.subscriptionOrder?.subscriptionOrderId}</NavLink>
                                                        : <span style={{ width: getColumnWidth(paymentHead, 0) }}>{data?.subscriptionOrder?.subscriptionOrderId || '---'}</span>
                                                }
                                            </TableCell>
                                            <TableCell style={{ width: getColumnWidth(paymentHead, 1) }}><span style={{ width: getColumnWidth(paymentHead, 1) }}>{data?.subscriptionOrder?.vendorReferenceId || '---'}</span></TableCell>
                                            <TableCell style={{ width: getColumnWidth(paymentHead, 2) }}><span style={{ width: getColumnWidth(paymentHead, 2) }}>{data?.subscriptionOrder?.subscriptionOrderDate ? moment(data?.subscriptionOrder?.subscriptionOrderDate).format('DD MMM YYYY') : '---'}</span></TableCell>
                                            <TableCell style={{ width: getColumnWidth(paymentHead, 3) }}><span style={{ width: getColumnWidth(paymentHead, 3) }}>{data?.subscriptionOrder?.plan?.planAmount ? `₹ ${currencyFormat(data?.subscriptionOrder?.plan?.planAmount)}` : '---'}</span></TableCell>
                                            <TableCell style={{ width: getColumnWidth(paymentHead, 4) }}><span style={{ width: getColumnWidth(paymentHead, 4) }}>{data?.subscriptionPaymentStatus}</span></TableCell>
                                            <TableCell>
                                                <Space direction="horizontal" align="center" size={[0, 0]} className={classes.iconPadding}>
                                                    {/* {
                                                        roleManagement !== '' && checkCRUDPermission('Payment History', 'view', 'Admin') &&
                                                        <NavLink to={"#"} onClick={() => handleDownload(data)}>
                                                            <Image src={ViewIcon} preview={false} />
                                                        </NavLink>
                                                    } */}
                                                    {
                                                        roleManagement !== '' && data?.subscriptionPaymentStatus === 'CAPTURED' && checkCRUDPermission('Payment History', 'view', 'Admin') &&
                                                        <NavLink to={"#"} onClick={() => onView(data)}>
                                                            <Image src={ViewIcon} preview={false} />
                                                        </NavLink>
                                                    }
                                                </Space>
                                            </TableCell>
                                        </TableRow>
                                    )) : (
                                        <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                            <TableCell className={classes.textAlignCenter} colSpan={paymentHead.length}>
                                                <p className={clsx(classes.noResultsText, classes.textAlignCenter)}>There are No History of Payments Recorded</p>
                                            </TableCell>
                                        </TableRow>
                                    )
                                }
                            </React.Fragment>
                        )
                    }
                </>
            }
        />
    )
}